import Vue from 'vue'
import { Message, Spin, Modal, Input } from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.component('Message', Message).component('Spin', Spin).component('i-input', Input)
Vue.prototype.$Message = Message
Vue.prototype.$Spin = Spin
Vue.prototype.$Modal = Modal
